<template>
    <v-app id="main" :dark="!dark" :light="dark">
        <v-content>
            <v-card class="image-bg6-reduced image-bg">
                <vorsi-toolbar></vorsi-toolbar>
                <vorsi-headline></vorsi-headline>
            </v-card>
            <vorsi-overview></vorsi-overview>

            <vorsi-features></vorsi-features>

            <!--            <vorsi-services></vorsi-services>-->
        </v-content>

        <vorsi-footer></vorsi-footer>
    </v-app>
</template>

<script>
export default {
    data: () => ({
        dark: true,
    }),
};
</script>
